import { render, staticRenderFns } from "./WorkTask.vue?vue&type=template&id=7338e008&scoped=true"
import script from "./WorkTask.vue?vue&type=script&lang=ts"
export * from "./WorkTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7338e008",
  null
  
)

export default component.exports